<div class="input-group">
    <span class="input-group-text">{{ currencySymbol }}</span>
    <input type="number"
           class="form-control"
           [required]="required"
           [ngModel]="modelNumber"
           (ngModelChange)="onChange($event)"
           [min]="min"
           [max]="max">
</div>

